import { createActions, handleActions } from 'redux-actions';

const initState = {
  topData: [],
  middleData: [],
  bottomData: [],
  fetching: false,
  error: null,
};

export const creators = createActions({
  PROJECTEDCASHFLOW_TOP_REQUEST: (selectedYears, DateKey, ReportingDateKey) => ({
    selectedYears,
    DateKey,
    ReportingDateKey,
  }),
  PROJECTEDCASHFLOW_MIDDLE_REQUEST: (selectedYears, DateKey, ReportingDateKey) => ({
    selectedYears,
    DateKey,
    ReportingDateKey,
  }),
  PROJECTEDCASHFLOW_BOTTOM_REQUEST: (selectedYears, DateKey) => ({
    selectedYears,
    DateKey,
  }),
  PROJECTEDCASHFLOW_SUCCESS: (payload) => payload,
  PROJECTEDCASHFLOW_FAILURE: (payload) => payload,
});

const topReducer = (state, { payload }) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const middleReducer = (state, { payload }) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const bottomReducer = (state, { payload }) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    PROJECTEDCASHFLOW_TOP_REQUEST: topReducer,
    PROJECTEDCASHFLOW_MIDDLE_REQUEST: middleReducer,
    PROJECTEDCASHFLOW_BOTTOM_REQUEST: bottomReducer,
    PROJECTEDCASHFLOW_SUCCESS: successReducer,
    PROJECTEDCASHFLOW_FAILURE: failureReducer,
  },
  initState,
);
